/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Email_RequiredInputs */



/**
* | output |
* | --- |
* | "Email is required." |
*
* @param {Team_Manager_Email_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_email_required = /** @type {((inputs?: Team_Manager_Email_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Email_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L’e-mail est requis.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine E-Mail-Adresse ist erforderlich.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'email è obbligatoria.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Адрес электронной почты обязателен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se requiere correo electrónico.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("必须提供电子邮件地址。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メールアドレスは必須です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ईमेल की जरूरत है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("É necessário enviar um endereço de e-mail.")
	return /** @type {LocalizedString} */ ("Email is required.")
});